import { store } from '@/app/store';
import { asyncNewMessage } from '@/app/reducers/noticeSlice';
import { storage } from '@/utils/storage';

const POLL_INTERVAL = 60000;
let rafId = 0;
let lastPollTime = 0;
let hadToken = false;
let lastSystemTime = undefined;

const poll = async () => {
  const token = storage.get('token');
  if (!token) return;
  const result = await store.dispatch(asyncNewMessage({ last_time: lastSystemTime, step_secend: POLL_INTERVAL / 1000 }));
  if (result.payload?.system_time) {
    lastSystemTime = result.payload.system_time;
  }
};

const tick = () => {
  const token = storage.get('token');
  const hasToken = !!token;

  if (hasToken && !hadToken) {
    hadToken = true;
    lastPollTime = Date.now();
    poll();
  } else if (!hasToken) {
    hadToken = false;
  }

  const now = Date.now();
  if (now - lastPollTime >= POLL_INTERVAL) {
    lastPollTime = now;
    poll();
  }
  rafId = requestAnimationFrame(tick);
};

export const startNoticePoller = () => {
  if (rafId) return;
  rafId = requestAnimationFrame(tick);
};

export const stopNoticePoller = () => {
  if (rafId) {
    cancelAnimationFrame(rafId);
    rafId = 0;
  }
  lastSystemTime = undefined;
  lastPollTime = 0;
  hadToken = false;
};